import { useMemo } from 'react';
import { useCommonTranslation } from 'hooks/i18n/useCommonTranslation';
import { getDaysInMonthOfLeapYear } from 'utils/dateUtil';
import {
  KioskChoiceButton,
  KioskChoiceGrid,
  KioskEntryButton,
  KioskEntryMessageBoxStyled,
  KioskRowGroup,
} from 'containers/public/kiosk/Kiosk.styled';
import { KioskLayout } from 'containers/public/kiosk/KioskLayout';

// Design px. The widest day number, 31, needs this width at --fontxl.
const MIN_WIDTH_TO_HOLD_DAY_NUMBER = 96;

// Design px. Lower than the other kiosk buttons, so that the four rows of days
// and the Back button fit on the screen.
const DAY_BUTTON_HEIGHT = 120;

export const KioskEntryBirthDay = ({
  month,
  onDaySelected,
  onBackClicked,
}: {
  month: number;
  onDaySelected: (day: number) => void;
  onBackClicked: () => void;
}) => {
  const { t } = useCommonTranslation();
  const days = useMemo(
    () =>
      Array.from(
        { length: getDaysInMonthOfLeapYear(month) },
        (_, idx) => idx + 1,
      ),
    [month],
  );

  return (
    <KioskLayout>
      <KioskEntryMessageBoxStyled>
        <div>{t('kiosk-checkin-birth-day-hint')}</div>
        <KioskChoiceGrid
          $maxColumns={8}
          $minColumnWidth={MIN_WIDTH_TO_HOLD_DAY_NUMBER}
          $rowHeight={DAY_BUTTON_HEIGHT}
        >
          {days.map((day) => (
            <KioskChoiceButton
              key={day}
              type="button"
              onClick={() => onDaySelected(day)}
            >
              {day}
            </KioskChoiceButton>
          ))}
        </KioskChoiceGrid>

        <KioskRowGroup>
          <KioskEntryButton
            type="button"
            variant="secondary"
            onClick={onBackClicked}
          >
            {t('back')}
          </KioskEntryButton>
        </KioskRowGroup>
      </KioskEntryMessageBoxStyled>
    </KioskLayout>
  );
};
